import { render, staticRenderFns } from "./SalesDetailOrderCustomer.vue?vue&type=template&id=9e5859d2&scoped=true&"
import script from "./SalesDetailOrderCustomer.vue?vue&type=script&lang=js&"
export * from "./SalesDetailOrderCustomer.vue?vue&type=script&lang=js&"
import style0 from "./SalesDetailOrderCustomer.vue?vue&type=style&index=0&id=9e5859d2&lang=scss&scoped=true&"
import style1 from "./SalesDetailOrderCustomer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e5859d2",
  null
  
)

export default component.exports